import { render, staticRenderFns } from "./UsersPerDayGraph.vue?vue&type=template&id=5b210d96&scoped=true&"
import script from "./UsersPerDayGraph.vue?vue&type=script&lang=js&"
export * from "./UsersPerDayGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b210d96",
  null
  
)

export default component.exports